import checkout from "./form";

const {
  formField: { reportingUnit, address, time, type, unit, total },
} = checkout;

const initialValues = {
  [reportingUnit.name]: "",
  [address.name]: "",
  [time.name]: "",
  [type.name]: "",
  [unit.name]: "",
  [total.name]: "",
};

export default initialValues;
